import type { Movie } from "../types";

export const movies: Movie[] = [
  {
    id: 1,
    title: "星海彼岸",
    originalTitle: "Beyond the Star Sea",
    year: 2026,
    region: "中国大陆",
    genres: ["科幻", "冒险", "剧情"],
    rating: 8.9,
    duration: 142,
    director: "陈屿",
    cast: ["林澈", "苏晚", "陆沉"],
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%2C%20glowing%20deep%20space%20nebula%20with%20a%20lone%20astronaut%20silhouette%20before%20a%20giant%20ringed%20planet%2C%20teal%20and%20gold%20accents%2C%20dramatic%20volumetric%20light%2C%20minimal%20elegant%20vertical%20poster%20composition&width=600&height=900&seq=movie-cover-01&orientation=portrait",
    synopsis:
      "人类首批深空探索者踏上寻找第二家园的旅程。当飞船信号在星海深处中断，唯一幸存的女工程师必须在孤独与希望之间做出抉择，而宇宙的尽头藏着人类从未预料的答案。",
    hot: 98,
  },
  {
    id: 2,
    title: "暗夜追凶",
    originalTitle: "The Night Chaser",
    year: 2025,
    region: "中国大陆",
    genres: ["悬疑", "犯罪", "惊悚"],
    rating: 8.4,
    duration: 126,
    director: "周昊",
    cast: ["郑川", "许宁", "白栎"],
    cover: "https://readdy.ai/api/search-image?query=Crime%20thriller%20movie%20poster%2C%20rainy%20neon%20lit%20city%20alley%20at%20night%20with%20a%20lone%20detective%20in%20a%20long%20coat%2C%20moody%20teal%20shadows%20and%20amber%20reflections%20on%20wet%20asphalt%2C%20tense%20atmospheric%20vertical%20poster%2C%20cinematic%20noir&width=600&height=900&seq=movie-cover-02&orientation=portrait",
    synopsis:
      "连续七起悬案指向同一位沉默的目击者。老刑警与年轻法医在层层迷雾中追查真相，却发现所有线索都回到十二年前那场被掩埋的火灾。",
    hot: 93,
  },
  {
    id: 3,
    title: "云上之光",
    originalTitle: "Light Above the Clouds",
    year: 2025,
    region: "中国大陆",
    genres: ["剧情", "家庭", "励志"],
    rating: 8.7,
    duration: 118,
    director: "苏青",
    cast: ["何舟", "温言", "林小满"],
    cover: "https://readdy.ai/api/search-image?query=Warm%20drama%20movie%20poster%2C%20a%20lone%20figure%20standing%20on%20a%20mountain%20hilltop%20above%20a%20sea%20of%20golden%20sunrise%20clouds%2C%20hopeful%20soft%20light%2C%20Gentle%20amber%20and%20cream%20tones%2C%20painterly%20cinematic%20vertical%20poster%20composition&width=600&height=900&seq=movie-cover-03&orientation=portrait",
    synopsis:
      "一位乡村教师在海拔三千米的云巅小学守了整整二十年。当最后一届学生即将毕业，一封来自城市的信让他的坚守有了新的意义。",
    hot: 90,
  },
  {
    id: 4,
    title: "钢铁纪元",
    originalTitle: "Iron Era",
    year: 2026,
    region: "美国",
    genres: ["动作", "科幻", "冒险"],
    rating: 8.2,
    duration: 148,
    director: "Ethan Cole",
    cast: ["Marcus Reed", "Elena Vasquez", "Jonah Pike"],
    cover: "https://readdy.ai/api/search-image?query=Epic%20action%20sci-fi%20movie%20poster%2C%20a%20towering%20mecha%20robot%20standing%20before%20a%20futuristic%20industrial%20city%20skyline%2C%20cool%20steel%20blue%20tones%20with%20glowing%20amber%20sparks%2C%20dramatic%20scale%2C%20bold%20cinematic%20vertical%20poster%20design&width=600&height=900&seq=movie-cover-04&orientation=portrait",
    synopsis:
      "在机械文明统治的未来，一名废铁场的年轻技师意外激活了沉睡百年的战争机体。为了守护被奴役的家乡，他将驾驶钢铁巨兽挑战整个纪元。",
    hot: 95,
  },
  {
    id: 5,
    title: "春风十里",
    originalTitle: "Ten Miles of Spring Breeze",
    year: 2024,
    region: "中国大陆",
    genres: ["爱情", "剧情"],
    rating: 7.9,
    duration: 112,
    director: "沈知",
    cast: ["顾南", "乔木", "叶青"],
    cover: "https://readdy.ai/api/search-image?query=Romantic%20drama%20movie%20poster%2C%20a%20young%20couple%20silhouette%20beneath%20blooming%20cherry%20blossom%20trees%20in%20a%20sunlit%20spring%20lane%2C%20soft%20pastel%20pink%20and%20fresh%20green%20tones%2C%20dreamy%20gentle%20bokeh%2C%20elegant%20vertical%20poster%20composition&width=600&height=900&seq=movie-cover-05&orientation=portrait",
    synopsis:
      "小城的春天来得特别慢。录音师与花店女孩在一次偶然的雨夜相遇，两人用整整一个春天，学会如何把心事说出口。",
    hot: 82,
  },
  {
    id: 6,
    title: "无声证词",
    originalTitle: "Silent Testimony",
    year: 2025,
    region: "中国大陆",
    genres: ["悬疑", "犯罪", "剧情"],
    rating: 8.5,
    duration: 130,
    director: "赵砚",
    cast: ["程野", "梁悦", "韩朔"],
    cover: "https://readdy.ai/api/search-image?query=Mystery%20drama%20movie%20poster%2C%20a%20dark%20courtroom%20desk%20scattered%20with%20case%20files%20and%20a%20magnifying%20glass%20under%20a%20single%20cold%20light%2C%20tense%20blue%20grey%20tones%2C%20high%20contrast%20cinematic%20vertical%20poster%20with%20deep%20shadows&width=600&height=900&seq=movie-cover-06&orientation=portrait",
    synopsis:
      "一场没有凶手的谋杀案，唯一的证人是位无法言语的聋哑画师。检察官必须用一幅幅画作，拼凑出被沉默掩盖的真相。",
    hot: 88,
  },
  {
    id: 7,
    title: "龙脊",
    originalTitle: "The Dragon Ridge",
    year: 2024,
    region: "中国大陆",
    genres: ["冒险", "动作", "奇幻"],
    rating: 7.8,
    duration: 135,
    director: "高岩",
    cast: ["岳峰", "温梨", "石岩"],
    cover: "https://readdy.ai/api/search-image?query=Epic%20adventure%20movie%20poster%2C%20a%20treacherous%20snow%20mountain%20ridge%20with%20a%20vast%20dragon%20shadow%20coiling%20behind%20the%20peaks%2C%20cool%20icy%20blue%20and%20pristine%20white%20tones%2C%20mythic%20scale%2C%20majestic%20vertical%20poster%20composition&width=600&height=900&seq=movie-cover-07&orientation=portrait",
    synopsis:
      "传说龙脊之上藏着能呼风唤雨的神物。一支探险队为寻找失踪的科考队员深入雪山，却在风雪与古老传说的夹缝中直面人性的深渊。",
    hot: 76,
  },
  {
    id: 8,
    title: "时光信笺",
    originalTitle: "Letters Through Time",
    year: 2023,
    region: "日本",
    genres: ["爱情", "奇幻", "剧情"],
    rating: 8.3,
    duration: 116,
    director: "佐藤遥",
    cast: ["中村里奈", "小林遥斗", "山口千夏"],
    cover: "https://readdy.ai/api/search-image?query=Fantasy%20romance%20movie%20poster%2C%20floating%20vintage%20letters%20and%20antique%20clock%20gears%20drifting%20in%20a%20warm%20golden%20haze%2C%20delicate%20amber%20and%20teal%20tones%2C%20nostalgic%20dreamy%20vertical%20poster%20with%20soft%20glow&width=600&height=900&seq=movie-cover-08&orientation=portrait",
    synopsis:
      "旧钟表店的角落藏着一台能寄信到过去的复古信箱。女孩写给十年前自己的信意外改变了一切，她必须在改写与放下之间重新认识爱。",
    hot: 84,
  },
  {
    id: 9,
    title: "深渊回响",
    originalTitle: "Echoes of the Abyss",
    year: 2026,
    region: "美国",
    genres: ["科幻", "惊悚", "冒险"],
    rating: 8.1,
    duration: 138,
    director: "Nora Blake",
    cast: ["Ava Sinclair", "Leo Marsh", "Iris Chen"],
    cover: "https://readdy.ai/api/search-image?query=Sci-fi%20horror%20movie%20poster%2C%20the%20dark%20deep%20ocean%20abyss%20with%20a%20faintly%20glowing%20bioluminescent%20creature%20lurking%20below%20a%20tiny%20submarine%2C%20deep%20teal%20and%20abyssal%20blue%20tones%2C%20ominous%20cinematic%20vertical%20poster%20with%20god%20rays&width=600&height=900&seq=movie-cover-09&orientation=portrait",
    synopsis:
      "全球最深的马里亚纳海沟传来规律的低频回响。深海科考队下潜万米，却发现那里等待他们的，是远比黑暗更古老的秘密。",
    hot: 87,
  },
  {
    id: 10,
    title: "城市之光",
    originalTitle: "City Lights",
    year: 2024,
    region: "中国香港",
    genres: ["剧情", "犯罪"],
    rating: 8.0,
    duration: 121,
    director: "梁天成",
    cast: ["陆维", "何嘉欣", "陈子豪"],
    cover: "https://readdy.ai/api/search-image?query=Urban%20drama%20movie%20poster%2C%20a%20sprawling%20harbour%20city%20skyline%20at%20dusk%20with%20warm%20window%20lights%20reflecting%20on%20the%20river%2C%20rich%20amber%20and%20deep%20teal%20tones%2C%20cinematic%20wide%20vertical%20poster%20with%20haze&width=600&height=900&seq=movie-cover-10&orientation=portrait",
    synopsis:
      "霓虹之下，小巷保安与夜班出租车司机共享着同一座城市的孤独。一桩看似无关紧要的小事，让两条平行的人生在黎明前交汇。",
    hot: 79,
  },
  {
    id: 11,
    title: "逆光而行",
    originalTitle: "Against the Light",
    year: 2023,
    region: "中国大陆",
    genres: ["剧情", "励志", "家庭"],
    rating: 7.7,
    duration: 109,
    director: "孙铭",
    cast: ["夏川", "柳絮", "周舟"],
    cover: "https://readdy.ai/api/search-image?query=Inspirational%20drama%20movie%20poster%2C%20a%20determined%20runner%20silhouette%20against%20a%20blazing%20sunrise%20on%20an%20empty%20road%2C%20strong%20warm%20orange%20backlight%20and%20long%20shadow%2C%20uplifting%20cinematic%20vertical%20poster%20composition&width=600&height=900&seq=movie-cover-11&orientation=portrait",
    synopsis:
      "一位失去一条腿的少年重新站上跑道。在父亲的沉默陪伴与教练的严厉要求下，他用每一步证明：光永远在逆行的方向。",
    hot: 71,
  },
  {
    id: 12,
    title: "幻境迷宫",
    originalTitle: "Maze of Illusions",
    year: 2025,
    region: "英国",
    genres: ["奇幻", "冒险", "悬疑"],
    rating: 8.2,
    duration: 133,
    director: "Oliver Grant",
    cast: ["Freya Hunt", "Caleb Stone", "Mia Rowe"],
    cover: "https://readdy.ai/api/search-image?query=Fantasy%20adventure%20movie%20poster%2C%20an%20impossible%20glowing%20crystal%20labyrinth%20with%20mirrored%20walls%20and%20soft%20teal%20light%2C%20warm%20gold%20sparkles%20drifting%2C%20mysterious%20elegant%20vertical%20poster%20with%20deep%20perspective&width=600&height=900&seq=movie-cover-12&orientation=portrait",
    synopsis:
      "每进入一次迷宫，记忆就会被改写一次。为了找回失踪的妹妹，少女必须在幻境崩解之前，辨清哪一个才是真正的自己。",
    hot: 83,
  },
  {
    id: 13,
    title: "长夜将尽",
    originalTitle: "Before the Dawn",
    year: 2024,
    region: "韩国",
    genres: ["悬疑", "剧情", "惊悚"],
    rating: 8.4,
    duration: 124,
    director: "金敏秀",
    cast: ["朴志勋", "李秀雅", "崔民浩"],
    cover: "https://readdy.ai/api/search-image?query=Suspense%20thriller%20movie%20poster%2C%20a%20single%20dim%20lamp%20in%20a%20dark%20empty%20room%20casting%20long%20shadows%20across%20bare%20walls%2C%20cold%20desaturated%20grey%20and%20pale%20teal%20tones%2C%20minimal%20tense%20vertical%20poster&width=600&height=900&seq=movie-cover-13&orientation=portrait",
    synopsis:
      "小镇的最后一盏路灯熄灭的那个夜晚，三名陌生人被同一场停电困在便利店。当黎明到来，他们才发现彼此都攥着同一个秘密。",
    hot: 85,
  },
  {
    id: 14,
    title: "侠影江湖",
    originalTitle: "Shadow of the Swordsman",
    year: 2022,
    region: "中国大陆",
    genres: ["武侠", "动作", "剧情"],
    rating: 8.1,
    duration: 137,
    director: "古云",
    cast: ["白鹤", "洛霜", "秦川"],
    cover: "https://readdy.ai/api/search-image?query=Chinese%20wuxia%20movie%20poster%2C%20a%20swordsman%20silhouette%20in%20a%20misty%20ink-wash%20bamboo%20forest%20with%20a%20drawn%20blade%2C%20muted%20jade%20green%20and%20ink%20black%20tones%2C%20poetic%20elegant%20vertical%20poster%20with%20negative%20space&width=600&height=900&seq=movie-cover-14&orientation=portrait",
    synopsis:
      "退隐多年的剑客为护送一件不起眼的信物重出江湖。一路上追杀不断，他渐渐明白，真正要护的不是东西，而是一段被遗忘的承诺。",
    hot: 74,
  },
  {
    id: 15,
    title: "归途",
    originalTitle: "The Way Home",
    year: 2023,
    region: "中国大陆",
    genres: ["剧情", "家庭"],
    rating: 8.6,
    duration: 115,
    director: "冯知远",
    cast: ["吴桐", "宋宜", "小雨"],
    cover: "https://readdy.ai/api/search-image?query=Family%20drama%20movie%20poster%2C%20a%20winding%20country%20road%20through%20golden%20autumn%20fields%20with%20a%20distant%20father%20and%20child%20walking%20hand%20in%20hand%2C%20warm%20nostalgic%20amber%20and%20rust%20tones%2C%20tender%20vertical%20poster%20composition&width=600&height=900&seq=movie-cover-15&orientation=portrait",
    synopsis:
      "在外打拼十年的游子带着一身疲惫回到故乡，只为送父亲最后一程。旧屋、旧街、旧邻居，让他重新读懂了那个沉默了一辈子的男人。",
    hot: 86,
  },
  {
    id: 16,
    title: "极速边界",
    originalTitle: "Edge of Speed",
    year: 2025,
    region: "美国",
    genres: ["动作", "赛车", "冒险"],
    rating: 7.6,
    duration: 128,
    director: "Ryan Ford",
    cast: ["Jason Vale", "Nina Park", "Owen Bliss"],
    cover: "https://readdy.ai/api/search-image?query=High%20octane%20racing%20action%20movie%20poster%2C%20a%20sleek%20sports%20car%20drifting%20on%20a%20neon-lit%20night%20track%20with%20motion%20blur%20and%20flying%20sparks%2C%20vivid%20red%20and%20amber%20accents%20on%20dark%20asphalt%2C%20dynamic%20vertical%20poster&width=600&height=900&seq=movie-cover-16&orientation=portrait",
    synopsis:
      "地下车手为救回被黑帮控制的妹妹，被迫参加一场没有规则、没有终点线的非法竞速。油门踩到底容易，守住底线却要付出一切。",
    hot: 78,
  },
  {
    id: 17,
    title: "山海奇缘",
    originalTitle: "Tales of the Mountains and Seas",
    year: 2024,
    region: "中国大陆",
    genres: ["动画", "奇幻", "家庭"],
    rating: 8.5,
    duration: 104,
    director: "叶知秋",
    cast: ["阿糯", "小山", "云谣"],
    cover: "https://readdy.ai/api/search-image?query=Whimsical%20animated%20family%20movie%20poster%2C%20colorful%20mythical%20creatures%20frolicking%20among%20floating%20islands%20above%20a%20turquoise%20sea%2C%20bright%20playful%20teal%20gold%20and%20coral%20palette%2C%20charming%20storybook%20vertical%20poster&width=600&height=900&seq=movie-cover-17&orientation=portrait",
    synopsis:
      "贪玩的小山神意外打翻了封印山海异兽的琉璃瓶。为了在月亮升起前收回所有异兽，她和话痨的上古神兽踏上了一场啼笑皆非的冒险。",
    hot: 89,
  },
  {
    id: 18,
    title: "孤岛来信",
    originalTitle: "Letters from the Isle",
    year: 2022,
    region: "法国",
    genres: ["剧情", "悬疑", "爱情"],
    rating: 8.0,
    duration: 119,
    director: "Camille Laurent",
    cast: ["Sophie Mercier", "Louis Blanc", "Ana Petit"],
    cover: "https://readdy.ai/api/search-image?query=Moody%20mystery%20drama%20movie%20poster%2C%20a%20lone%20lighthouse%20on%20a%20rocky%20island%20surrounded%20by%20a%20stormy%20grey%20sea%2C%20crashing%20waves%20and%20moody%20blue-grey%20tones%20with%20a%20warm%20lamp%20glow%2C%20cinematic%20vertical%20poster&width=600&height=900&seq=movie-cover-18&orientation=portrait",
    synopsis:
      "灯塔看守人每周都会收到一封没有寄件人的信。当信件突然中断，她决定跨越风暴海峡，去寻找那个只存在于字里行间的陌生人。",
    hot: 73,
  },
];

export const genres = [
  "动作",
  "科幻",
  "剧情",
  "爱情",
  "悬疑",
  "犯罪",
  "奇幻",
  "冒险",
  "动画",
  "武侠",
  "家庭",
  "惊悚",
  "励志",
  "赛车",
];

export const regions = [
  "中国大陆",
  "美国",
  "日本",
  "韩国",
  "英国",
  "法国",
  "中国香港",
];

export const yearsList = [2026, 2025, 2024, 2023, 2022];

export const ratingRanges = [
  { label: "9.0 分以上", min: 9.0, max: 10 },
  { label: "8.0 - 9.0 分", min: 8.0, max: 9.0 },
  { label: "7.0 - 8.0 分", min: 7.0, max: 8.0 },
  { label: "7.0 分以下", min: 0, max: 7.0 },
];

export const locations = ["中国大陆", "中国香港", "美国", "日本", "韩国", "英国", "法国"];